/* eslint-disable react/prop-types */ // TODO: add props
import _ from 'lodash';
import { UniqueOverlayTrigger } from 'edrolo/domains/overlays';
import classNames from 'classnames';

// TODO: Passing NaN causes react to think the children are getting mutated!
const TrafficLightIndicator = (props) => {
  const diff = props.b ? props.a - props.b : 0;

  const classes = classNames({
    indicator: true,
    average: true,
    'bg-light-green': diff > 5,
    'bg-orange': diff < -5,
    'bg-amber': diff >= -5 && diff <= 5,
  });

  const button = (
    <button className={`button-legacy ${classes}`}>{props.children}</button>
  );

  // uniqueOverlayId should be determined from redux state, but was too hard in this case
  if (props.popover) {
    return (
      <UniqueOverlayTrigger
        trigger="click"
        placement="right"
        rootClose
        uniqueOverlayId={`traffic-light-${_.uniqueId()}`}
        renderOverlay={() => props.popover}
      >
        {button}
      </UniqueOverlayTrigger>
    );
  }

  return button;
};

export default TrafficLightIndicator;
